<div class="form-group">
  @if (showLabel && (question?.question_copy || question?.email_version)) {
    <label
      [innerHtml]="question?.question_copy || question?.email_version" class="form-group__label">
    </label>
  }

  <div class="input-wrap">
    <input mask="percent" type="text" [name]="uniqueControlName" [id]='uniqueId'
      [placeholder]="question?.question_prompt" class="form-control" [(ngModel)]="value" (ngModelChange)="saveValue()"
      [disabled]="readOnly" class="form-control text-right">
      <div class="input-wrap-append">
        <div class="input-wrap-symbol">
          %
        </div>
      </div>
    </div>
  </div>